import React, { useState, useContext } from 'react'
import styled from 'styled-components'
import { Flex } from 'reflexbox/styled-components'
import PropTypes from 'prop-types'

import baseTheme from 'theme'
import media from 'media'

import UniversalLink from 'components/UniversalLink'
import Button from 'components/Button'
import Brand from '@anvilco-pkg/ui/components/Brand'
import { BannerContext } from 'components/Banner'
import { BANNER_HEIGHT } from 'components/Banner/AITopBanner'
import MobileNavbar from './MobileNavbar'

import { NAV_BAR_HEIGHT, MOBILE_NAV_BAR_HEIGHT } from 'consts'
import { BACKGROUND_COLOR } from 'styles/GlobalStyle'
import { APP_URL, SCROLL_NAME_CONTACT_SALES } from 'helpers'

const OFFSET_HEIGHT = 272
const OFFSET_HEIGHT_LG = 310

export const NavbarContainer = styled.div.withConfig({
  shouldForwardProp: (prop) =>
    ['isAIBanner', 'showLargeCard'].indexOf(prop) === -1,
})`
  position: sticky;
  top: 0;
  ${({ isAIBanner }) => isAIBanner && `margin-top: ${BANNER_HEIGHT}px;`}

  transition: height 0.3s ease;
  font-size: 16px;
  background-color: ${BACKGROUND_COLOR};
  width: 100%;
  overflow: hidden;
  transition: height 0.3s ease;
  display: none;

  &::after {
    width: 100%;
    box-shadow: rgba(30, 30, 30, 0.04) 0px -4px 15px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -12px;
    height: 12px;
    content: ' ';
    background: transparent;
    z-index: 99;
  }

  ${media.giant`
    min-height: ${NAV_BAR_HEIGHT}px;
    max-height: ${NAV_BAR_HEIGHT + `${({ showLargeCard }) => (showLargeCard ? OFFSET_HEIGHT_LG : OFFSET_HEIGHT)}`}px;
    display: block;
    z-index: 99;
  `}
`
const NavbarWrapper = styled.div`
  display: none;
  background-color: ${BACKGROUND_COLOR};
  align-items: center;
  color: white;
  position: sticky;
  top: 0px;
  z-index: 99;
  justify-content: center;
  width: 100%;

  ${media.giant`
    display: flex;
  `}
`

const NavbarInnerContainer = styled(Flex).attrs({
  justifyContent: ['space-around'],
})`
  width: 100%;
  max-width: ${baseTheme.paperMaxWidth}px;
`

const MobileNavbarContainer = styled(Flex)`
  position: sticky;
  width: 100%;

  top: 0px;
  z-index: 99;

  ${media.desktop`
      ${({ isAIBanner }) => isAIBanner && `margin-top: ${BANNER_HEIGHT}px;`}
  `}
  ${media.giant`
    display: none;
  `}
`

const Menu = styled.div`
  position: relative;
  cursor: default;
  color: #000 !important;
  font-weight: ${baseTheme.fontWeights.bold};
  line-height: 26px;

  &:hover::after {
    content: '';
    width: 100%;
    position: absolute;
    bottom: -4px;
    left: 0;
    height: 3px;
    background-color: ${baseTheme.colors.hoverGreen};
  }
`

const Dropdown = styled.div`
  padding-bottom: 40px;
  background-color: ${baseTheme.colors.offWhite};
  justify-content: space-around;
  width: 100%;
`
const ToggleButtonContainer = styled(Flex).attrs({
  alignItems: ['center'],
  flexDirection: ['row'],
})`
  min-height: ${MOBILE_NAV_BAR_HEIGHT}px;
  flex-shrink: 0;
  width: 100%;

  padding-left: 30px;
  padding-right: 30px;

  ${media.desktop`
    width: auto;
    padding-left: 0;
    min-height: ${NAV_BAR_HEIGHT}px;
  `}
`

const NavbarLinkStyled = styled(UniversalLink)`
  padding: 0px;
`

const RightButtonContainer = styled(Flex).attrs({
  alignItems: ['center'],
  flexDirection: ['column', 'row'],
})``

const RightLinkButton = styled(Button)`
  height: min-content;
  margin-left: 30px;
  margin-right: 30px;
  color: ${baseTheme.colors.black} !important;
  font-size: ${baseTheme.fontSizes[50]}px !important;
  font-weight: ${baseTheme.fontWeights.bold} !important;

  &:hover,
  &.active {
    text-decoration: none;
    color: ${baseTheme.colors.black};
  }

  ${media.giant`
    margin-left: 22px;
    margin-right: 15px;
  `}
`

const CTAButton = styled(Button)`
  box-shadow: none;

  &:hover,
  &:hover:not(.active) {
    box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 15px 0px !important;
  }
`

const SecondaryCtaButton = styled(CTAButton)`
  border: 2px solid ${baseTheme.colors.green} !important;
  &:hover,
  &:hover:not(.active) {
    border-color: ${baseTheme.colors.hoverGreen} !important;
  }
  && {
    border-color: ${baseTheme.colors.green} !important;
  }
  ${media.giant`
    margin-right: 15px;
  `}
`
const Container = styled(Flex).attrs({
  alignItems: ['flex-start'],
  justifyContent: ['center'],
})`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  gap: 41px;
  cursor: default;
`

const SubmenuDesc = styled.div.withConfig({
  shouldForwardProp: (prop) => ['dark'].indexOf(prop) === -1,
})`
  text-align: left;
  font-size: ${baseTheme.fontSizes[30]}px;
  color: ${({ dark }) =>
    dark ? baseTheme.colors.white : baseTheme.colors.black};
  text-decoration: none;
  font-weight: ${baseTheme.fontWeights.thin};
`
const ColumnTitle = styled(Flex).attrs({
  alignItems: ['center'],
  justifyContent: ['center'],
  flexDirection: ['column'],
  my: ['8px'],
})`
  font-weight: ${baseTheme.fontWeights.bold};
`

const Column = styled(UniversalLink).withConfig({
  shouldForwardProp: (prop) => ['bg', 'border', 'dark'].indexOf(prop) === -1,
})`
  height: 195px;
  width: 250px;
  background-color: ${({ bg }) => bg ?? baseTheme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 31px 33px;
  color: ${({ dark }) => (dark ? baseTheme.colors.white : baseTheme.colors.black)} !important;
  border: 2px solid ${({ bg }) => bg ?? baseTheme.colors.blacks[10]};
  :hover {
    box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
    text-decoration: none;
    border 2px solid ${({ border }) => border};

    ${ColumnTitle} {
      text-decoration: underline;
    }
  }

  ${SubmenuDesc} {
    text-align: center;
  }
`

const SubmenuInfo = styled(Flex).attrs({
  flexDirection: ['column'],
})`
  color: ${baseTheme.colors.blacks[70]};
  text-decoration: none;
  &:hover {
    color: ${baseTheme.colors.black};
  }
`

const GridContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => ['showLargeCard'].indexOf(prop) === -1,
})`
  display: grid;
  grid-template-columns: repeat(
    ${({ showLargeCard }) => (showLargeCard ? 2 : 3)},
    1fr
  );
  gap: 8px;
`
const MenuItemContainer = styled(Flex).attrs({
  flexDirection: ['row'],
})`
  gap: 36px;
`
const NavbarLeftWrapper = styled(Flex).attrs({
  alignItems: ['center'],
})``

const BaseSubmenuCard = styled(UniversalLink)`
  width: 335px;
  display: flex;
  padding: 11px 14px;
  flex-direction: row;
  align-items: center;
  font-weight: ${baseTheme.fontWeights.bold};
  ${SubmenuInfo} {
    color: ${baseTheme.colors.blacks[70]} !important;
  }
  :hover {
    background-color: ${baseTheme.colors.white};
    ${SubmenuInfo} {
      color: ${baseTheme.colors.black} !important;
    }

    box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.08);
    text-decoration: none;
  }
`
const IconWrapper = styled(Flex).attrs({
  alignItems: ['center'],
  justifyContent: ['center'],
})`
  width: 38px;
  height: 38px;
  background-color: ${(props) =>
    props.bg ? props.bg : baseTheme.colors.blacks[10]};
  border-radius: 100px;
`
const SubmenuCard = styled(BaseSubmenuCard).withConfig({
  shouldForwardProp: (prop) => ['title', 'bgHover'].indexOf(prop) === -1,
})`
  &:hover ${IconWrapper} {
    background-color: ${(props) =>
      ['Resources', 'Developers'].includes(props.title)
        ? baseTheme.colors.greens[20]
        : props.bgHover};
  }
`
const SubmenuInnerCard = styled(Flex).attrs({
  alignItems: ['center'],
})`
  gap: 12px;
`

const ClickableMenu = styled(UniversalLink)`
  position: relative;
  cursor: pointer;
  color: #000 !important;
  font-weight: ${baseTheme.fontWeights.bold};
  line-height: 26px;
  display: block;

  &:hover {
    text-decoration: none;

    ::after {
      content: '';
      width: 100%;
      position: absolute;
      bottom: -4px;
      left: 0;
      height: 3px;
      background-color: ${baseTheme.colors.hoverGreen};
    }
  }
`

const Navbar = ({
  menuObject,
  hidePrimaryCta,
  simpleCtas,
  primaryCta = {
    text: 'Sign up',
    to: `${APP_URL}/signup`,
  },
  secondaryCta = {
    text: 'Get a demo',
    to: `${SCROLL_NAME_CONTACT_SALES}`,
  },
  isContentFullWidth = false,
  hideSecondaryCta = true,
  showLargeCard = false,
}) => {
  const defaultSelectedMenu = {
    value: false,
    menuItem: {
      title: '',
      subMenu: [],
    },
  }
  const [selectedMenuItem, setSelectedMenuItem] = useState(defaultSelectedMenu)
  const { isAIBanner } = useContext(BannerContext) || {}

  function renderToggleButton () {
    return (
      <ToggleButtonContainer>
        <NavbarLinkStyled to="/">
          <Brand />
        </NavbarLinkStyled>
      </ToggleButtonContainer>
    )
  }

  function renderRegularMenuItems () {
    const subMenus = selectedMenuItem.menuItem.subMenu
    return (
      <GridContainer showLargeCard={showLargeCard}>
        {subMenus.slice(showLargeCard ? 1 : 0).map((menu) => (
          <SubmenuCard
            title={selectedMenuItem.menuItem.title}
            key={menu.title}
            to={menu.to}
            bgHover={menu.bgHover ?? baseTheme.colors.greens[20]}
          >
            <SubmenuInnerCard>
              <IconWrapper bg={menu.bg ?? baseTheme.colors.blacks[10]}>
                {menu.icon}
              </IconWrapper>
              <SubmenuInfo>
                {menu.title}
                <SubmenuDesc>{menu.desc && menu.desc}</SubmenuDesc>
              </SubmenuInfo>
            </SubmenuInnerCard>
          </SubmenuCard>
        ))}
      </GridContainer>
    )
  }

  function renderHoverCard () {
    const subMenus = selectedMenuItem.menuItem.subMenu
    return selectedMenuItem.value ? (
      <Dropdown>
        <Container>
          {showLargeCard && (
            <Column
              to={subMenus[0]?.to}
              bg={subMenus[0]?.bg}
              border={subMenus[0]?.border}
              dark={subMenus[0]?.dark}
            >
              {subMenus[0]?.icon}
              <ColumnTitle>{subMenus[0]?.title}</ColumnTitle>
              <SubmenuDesc dark={subMenus[0]?.dark}>
                {subMenus[0]?.desc && subMenus[0]?.desc}
              </SubmenuDesc>
            </Column>
          )}
          {renderRegularMenuItems()}
        </Container>
      </Dropdown>
    ) : null
  }
  function renderRightButtons () {
    const LinkComp = (props) => (
      <RightLinkButton
        {...props}
        type="link"
        target="__blank"
        className="link"
      />
    )

    const PrimaryCTA = simpleCtas
      ? LinkComp
      : (props) => <CTAButton {...props} type="cta" size="large" withShadow />

    const SecondaryCTA = simpleCtas
      ? LinkComp
      : (props) => (
          <SecondaryCtaButton
            {...props}
            type="outline-default"
            className="link"
            size="large"
          />
        )
    return (
      <RightButtonContainer>
        <LinkComp
          type="link"
          to={`${APP_URL}/login`}
          target="__blank"
          className="link"
        >
          Login
        </LinkComp>
        {!hideSecondaryCta && (
          <SecondaryCTA target="__blank" to={secondaryCta.to}>
            {secondaryCta.text}
          </SecondaryCTA>
        )}
        {!hidePrimaryCta && (
          <PrimaryCTA to={primaryCta.to}>{primaryCta.text}</PrimaryCTA>
        )}
      </RightButtonContainer>
    )
  }
  function renderMenu () {
    return (
      <MenuItemContainer key="menu">
        {menuObject.map((menuItem, index) => (
          <div key={index}>
            {!menuItem?.subMenu ? (
              <ClickableMenu
                onMouseEnter={() => {
                  setSelectedMenuItem({
                    value: false,
                    menuItem: defaultSelectedMenu.menuItem,
                  })
                }}
                to={menuItem.to}
              >
                {menuItem.title}
              </ClickableMenu>
            ) : (
              <Menu
                onMouseEnter={() => {
                  setSelectedMenuItem({ value: true, menuItem })
                }}
                key={index}
              >
                {menuItem.title}
              </Menu>
            )}
          </div>
        ))}
      </MenuItemContainer>
    )
  }

  const offsetHeightCalculated = showLargeCard
    ? OFFSET_HEIGHT_LG
    : OFFSET_HEIGHT

  return (
    <>
      <MobileNavbarContainer isAIBanner={isAIBanner}>
        <MobileNavbar
          menuObject={menuObject}
          isContentFullWidth={isContentFullWidth}
          primaryCta={primaryCta}
          hidePrimaryCta={hidePrimaryCta}
          secondaryCta={secondaryCta}
          hideSecondaryCta={hideSecondaryCta}
        />
      </MobileNavbarContainer>

      <NavbarContainer
        id="top-level-navbar"
        style={{
          height: selectedMenuItem.value
            ? offsetHeightCalculated
            : NAV_BAR_HEIGHT,
        }}
        isAIBanner={isAIBanner}
        showLargeCard={showLargeCard}
        onMouseLeave={() => {
          setSelectedMenuItem({
            value: false,
            menuItem: defaultSelectedMenu.menuItem,
          })
        }}
      >
        <NavbarWrapper>
          <NavbarInnerContainer>
            <NavbarLeftWrapper>
              {renderToggleButton()}
              {renderMenu()}
            </NavbarLeftWrapper>
            {renderRightButtons()}
          </NavbarInnerContainer>
        </NavbarWrapper>
        {renderHoverCard()}
      </NavbarContainer>
    </>
  )
}

const ctaShape = {
  text: PropTypes.string.isRequired,
  to: PropTypes.string,
}

Navbar.propTypes = {
  primaryCta: PropTypes.shape(ctaShape),
  secondaryCta: PropTypes.shape(ctaShape),
  isContentFullWidth: PropTypes.bool,
  menuObject: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subMenu: PropTypes.arrayOf(
        PropTypes.shape({
          title: PropTypes.string.isRequired,
          subtitle: PropTypes.string,
          to: PropTypes.string.isRequired,
        })
      ),
    })
  ),
  hidePrimaryCta: PropTypes.bool,
  hideSecondaryCta: PropTypes.bool,
  simpleCtas: PropTypes.bool,
  showLargeCard: PropTypes.bool,
}

export default Navbar
